module.exports = __webpack_public_path__ + "img/4.88f98b91.jpg";